import Pagination, { PaginationProps } from './Pagination.component';

export type PaginationTypes = PaginationProps;

export default Pagination;
